<template>
  <div>
    <navigation @setMode="setMode"
                :mode="mode"
                @setContent="setContent"></navigation>
    <upload-file v-if="mode === 'existing' && content === null"
                 @content="setContent"></upload-file>
    <edit-file :content="content"
               @setContent="setContent"
               v-if="content !== null"></edit-file>
  </div>
</template>

<script>
import navigation from '@/components/nav'
import uploadFile from '@/components/upload'
import editFile from '@/components/edit'

export default {
  name: 'xmlmaker',
  data() {
    return {
      mode: '',
      content: null
    }
  },
  components: {
    navigation,
    uploadFile,
    editFile
  },
  methods: {
    setMode(v) {
      this.mode = v
      this.filelist = null
      this.content = null
    },
    setContent(v) {
      this.content = v
    }
  }
}
</script>
